import React from "react";
import SearchCheckUrl from "../SearchCheckUrl";

const SearchLeftPanel = () => {
  return (
    <SearchCheckUrl />
  )
}

export default SearchLeftPanel;